import { Product } from "@utilities/types";

export const getProductPurchasePrice = (product: Product) => {
    return product.productPurchasePrices?.[
        product.productPurchasePrices.length - 1
    ]?.price || 0;
}
